'use strict';

import './init';

// Custom scripts
import './custom/backings';
import './custom/cms';
import './custom/faux-links';
import './custom/image-uploads';
import './custom/image-upload-preview';
// import './custom/read-more';
import './custom/updateHash';
import './custom/carousel';
import './custom/datepicker';
import './custom/fixed-notice';
import './custom/inputEditedClass';
import './custom/relation_picker';
import './custom/wrap-selects';
import './custom/character-limit';
import './custom/donate';
import './custom/gtm_donation';
import './custom/inputTypeNumber';
import './custom/scroll';
import './custom/chart';
import './custom/dropdown';
import './custom/image-upload-limit';
import './custom/modal';
import './custom/tabs';
import './custom/close-status-header';
import './custom/events';
import './custom/image-upload-preview';
import './custom/navigation';
import './custom/toggle-password-fields';

$(document).ready(function() {
  bcn.init();
});
